//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
/* eslint-disable object-curly-newline */
import { ref, onMounted, onBeforeMount } from '@vue/composition-api'
import { useRouter, isAndroid, isIOS, openTab } from '@core/utils'
import { useUtils } from '@core/libs/i18n'
import themeConfig from '@themeConfig'

export default {
  setup() {
    const { route } = useRouter()
    const refVideo = ref(null)
    const { t } = useUtils()

    onBeforeMount(() => {
      refVideo.value = route.value.params.playback
      if (isAndroid() || isIOS()) {
        if (isIOS()) {
          // window.open().location = `fanaty://video?video_id=${refVideo.value}`
          openTab(`fanaty://video_detail/${refVideo.value}`)
        } else window.location = `fanaty://video_detail/${refVideo.value}`
      } else {
        openTab('https://www.fanaty.com')
      }
    })

    onMounted(async () => {
      if (isAndroid() || isIOS()) {
        setTimeout(() => {
          if (isIOS()) {
            window.location.href = 'https://apps.apple.com/us/app/fanaty/id1461051554'
          } else if (isAndroid()) {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.fanaty'
          }
        }, 5000)
      }
    })

    return {
      refVideo,

      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      openTab,

      t,
    }
  },
}
